import { Component } from '@angular/core';
import { NetworkStatusService } from './shared/services/network-status.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public isOnline = true;

  constructor(private networkStatus: NetworkStatusService,private networkService: NetworkStatusService,
    private snackBar: MatSnackBar) {
    this.networkStatus.isOnline$.subscribe(status => {
      this.isOnline = status;
    });
  }


  ngOnInit() {
    this.networkService.isOnline$.subscribe(isOnline => {
      if (!isOnline) {
        this.snackBar.open('🚫 No Internet Connection', 'Dismiss', {
          duration: 0,
          panelClass: 'no-internet-snackbar'
        });
      } else {
        this.snackBar.dismiss(); // Auto-hide when back online
      }
    });
  }

}
